import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { CrmContactPhoneNumberDto } from './crm-contact-phone-number.dto';
import { CrmContactSegmentDto } from './crm-contact-segment.dto';
import { CrmContactGender } from './crm-contact-gender.enum';

@Api('api/agentic-cx/crm-contact')
export class CrmContactDto extends DtoHasApi {
  id: number;
  firstName: string;
  lastName: string;
  email?: string | null;
  gender: CrmContactGender;
  birthDate?: string | null;
  idNumber?: string | null;
  address?: string | null;
  note?: string | null;
  noteUpdatedAt?: string | null;
  noteUpdatedByUserId?: string | null;
  noteUpdatedByName?: string | null;
  creationTime?: string | null;
  lastModificationTime?: string | null;
  phoneNumbers: CrmContactPhoneNumberDto[] = [];
  contactSegments: CrmContactSegmentDto[] = [];
  isActive?: boolean;
  deactivationTime?: string | null;
}

